import React from 'react';
import ButtonGroupPDF from "../../Modals/ButtonGroupsPDF";

export default function GroupDocuments(props) {
    return (
        <div>
            <ButtonGroupPDF groupId={props.group.groupId}/>
        </div>
    );
};